/**
 * Health Service
 * API functions for health checks
 */

import { httpClient } from '@/api/http/client'

/**
 * Health check response
 */
export interface HealthResponse {
  status: string
  [key: string]: unknown
}

/**
 * Health service API functions
 */
export const healthService = {
  /**
   * Get health check status
   */
  getHealth: (): Promise<HealthResponse> => {
    return httpClient.get<HealthResponse>('/health')
  },
}
